<template>
  <div class="ticket-processor-container">
    <a-spin :spinning="loading">
      <div v-if="detail.length" style="min-height: 260px">
        <alert-info-top
          :show-unit="false"
          :detail="detail"
          :img-height="18"
          :isNo="true"
        ></alert-info-top>
      </div>
      <div v-else style="min-height: 260px; position: relative; overflow: hidden;">
        <empty-component
          description="暂无数据"
          :imgUrl="require('@/assets/images/info_empty.png')"
          :body-style="{
            height: '176px',
            marginTop: '28px'
          }"
          :description-style="{
            marginTop: '-24px'
          }"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { getTicketTop } from '@/api/itsm'
import AlertInfoTop from '@/components/top/AlertInfoTop'
import EmptyComponent from '@/components/EmptyComponent.vue'
import { humanizeTime } from '@/utils/index.js'

export default {
  name: 'TicketDuration',
  components: {
    AlertInfoTop,
    EmptyComponent
  },
  data () {
    return {
      loading: false,
      detail: [],
      params: {
        datetime_from: moment().subtract(7, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        top_of: 'duration',
        limit: 5
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      getTicketTop(this.params).then(res => {
        if (res.data) {
          this.detail = res.data.data.map(item => {
            return {
              ...item,
              value: humanizeTime(item.value, true)
            }
          })
        } else this.detail = []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ticket-processor-container {
  :deep(#alert-info) {
    .alert-info-item {
      height: 42px;
      margin-bottom: 12px;
      font-size: 13px;
      line-height: 42px;
      // font-weight: 400;
      // padding: 6px 12px;
      .item-img {
        margin: 0 10px 2px 0;
      }
      .item-no {
        margin-right: 4px;
      }
      .item-value {
        font-size: 13px;
        line-height: 20px;
      }
    }
  }
}
</style>
